import { render, staticRenderFns } from "./newsSvg.vue?vue&type=template&id=7b498f28"
import script from "./newsSvg.vue?vue&type=script&lang=ts"
export * from "./newsSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports